// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoSection_videoContainer__KgXLq","playButton":"VideoSection_playButton__1QNwk"};